<template>
  <div class="Melamine">
    <div class="title">Propylene Glycol</div>

    <div class="table">
      <label>Specification:</label>
      <el-table border :data="tableData" stripe>
        <el-table-column prop="Items" label="Items" width="300">
        </el-table-column>
        <el-table-column prop="Unit" label="Unit"> </el-table-column>
        <el-table-column prop="Specification" label="Specification">
        </el-table-column>
      </el-table>
    </div>
    <div class="item-huanhang">
      <label>Package:</label>
      <p>215kg/drum, 17.2mt/20'FCL, 25.8mt/40'FCL, 23mt net flexKitank</p>
    </div>
    <div class="item-huanhang">
      <label>Applications:</label>
      <p>
        Forty-five percent of propylene glycol produced is useed as a chemical feedstock for the
production of unsaturated polyester resins. Propylene glycol is also tused in various edible items such
as coffee-based drinks, liquid sweeteners, ice cream, whipped dairy products and soda
Antifreeze, Electronic cigarettes liquid etc.
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "ACTdetail",
  data() {
    return {
      tableData:[
        { Items: "PG content", Unit: "Wt%", Specification: "99.80min" },
        { Items: "Moisture", Unit: "%", Specification: "0.01max" },
        { Items: "Density(20°C)", Unit: "g cm3", Specification: "1.035-1.040" },
        { Items: "Index of refraction", Unit: "nD20", Specification: "1.428-1.435" },
        { Items: "Acidity", Unit: "%", Specification: "0.02max" },
        { Items: "Distillation range", Unit: "℃", Specification: "183-190" },
        { Items: "Colourity(Pt-Co)", Unit: "APHA", Specification: "10" },
        { Items: "Appearance", Unit: "", Specification: "Colorless, Viscous, Transparent liquid" },
      ],
    };
  },
};
</script>

<style lang="less" scoped>
.Melamine {
  padding: 10px 30px;
  height: 100%;
  overflow-y: auto;
  label {
    font-size: 20px;
    font-weight: bold;
    height: 40px;
    line-height: 40px;
  }
  p {
    color: gray;
    font-weight: bold;
    line-height: 30px;
  }
  .title {
    font-size: 30px;
    font-weight: bold;
    color: #042a42cf;
  }
  .table {
    margin-top: 10px;
    display: flex;
    flex-direction: column;
  }
  .item {
    margin-top: 10px;
    display: flex;
    align-items: center;
    column-gap: 10px;
  }
  .item-huanhang {
    display: flex;
    flex-direction: column;
    column-gap: 20px;
  }
}
</style>
